export const SOKO_GRID_EMAIL = "sokogrid@gmail.com";
export const SOKO_GRID_PHONE_DISPLAY = "+254 100 264 521";
export const SOKO_GRID_PHONE_E164 = "+254100264521";
export const SOKO_GRID_WHATSAPP_DISPLAY = "+254 100 264 521";
export const SOKO_GRID_WHATSAPP_E164 = "254100264521";
export const SOKO_GRID_WEBSITE_DISPLAY = "sokogrid.com";
export const SOKO_GRID_WEBSITE_URL = "https://sokogrid.com";

export const SOKO_GRID_EMAIL_URL = `mailto:${SOKO_GRID_EMAIL}`;
export const SOKO_GRID_PHONE_URL = `tel:${SOKO_GRID_PHONE_E164}`;
export const SOKO_GRID_WHATSAPP_URL = `https://wa.me/${SOKO_GRID_WHATSAPP_E164}`;
